import { render, staticRenderFns } from "./ProductIntroOpenPlatform.vue?vue&type=template&id=12216dc0&scoped=true&"
import script from "./ProductIntroOpenPlatform.vue?vue&type=script&lang=js&"
export * from "./ProductIntroOpenPlatform.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroOpenPlatform.vue?vue&type=style&index=0&id=12216dc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12216dc0",
  null
  
)

export default component.exports